import React from 'react';
import { Lightbulb } from 'lucide-react';

interface PageSuggestionProps {
    children: React.ReactNode;
}

const PageSuggestion: React.FC<PageSuggestionProps> = ({ children }) => {
    return (
        <div className="mt-3 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
            <p>{children}</p>
        </div>
    );
};

export default PageSuggestion;
